import { render } from "./videogds.vue?vue&type=template&id=468c251b&scoped=true"
const script = {}

import "./videogds.vue?vue&type=style&index=0&id=468c251b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-468c251b"

export default script